import type { InfluencerCard } from "./LobbyType";

export type ListTab = "all" | "follow" | "sub";

export const isListTab = (v: string | null): v is ListTab =>
  v === "all" || v === "follow" || v === "sub";

/** 筛选项「我的关注」 */
export function matchesMyFollow(c: InfluencerCard): boolean {
  return c.favorStatus === 1;
}

/** 筛选项「我的订阅」 */
export function matchesMySub(c: InfluencerCard): boolean {
  return (
    c.membershipTag === "ACTIVE" ||
    c.membershipTag === "EXPIRED" ||
    c.subStatus === 1
  );
}

export function sortBySpaceName(cards: InfluencerCard[]): InfluencerCard[] {
  return [...cards].sort((a, b) =>
    a.name.localeCompare(b.name, "zh-Hans", { sensitivity: "base" })
  );
}

export function filterCards(
  cards: InfluencerCard[],
  tab: ListTab
): InfluencerCard[] {
  switch (tab) {
    case "follow":
      return sortBySpaceName(cards.filter(matchesMyFollow));
    case "sub":
      return sortBySpaceName(cards.filter(matchesMySub));
    case "all":
      return sortBySpaceName(cards);
  }
}

export function cornerLabel(tag: "ACTIVE" | "EXPIRED" | null): string | null {
  if (tag === "ACTIVE") {
    return "正在订阅";
  }
  if (tag === "EXPIRED") {
    return "曾经订阅";
  }
  return null;
}
